// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u_lA","rootNoMargin":"styles_rootNoMargin__1lznI"};